import DOMPurify from 'dompurify';

export const sanitizeHtml = (html) => {
  if (!html) return '';

  // 1. حذف تمام ویژگی‌های style و class (با regex ساده)
  let cleaned = html.replace(/\s+style\s*=\s*(?:"[^"]*"|'[^']*')/gi, '');
  cleaned = cleaned.replace(/\s+class\s*=\s*(?:"[^"]*"|'[^']*')/gi, '');

  // 2. پالایش با DOMPurify (تنها تگ‌های مجاز را نگه می‌دارد)
  return DOMPurify.sanitize(cleaned, {
    ALLOWED_TAGS: [
      'p', 'br', 'b', 'strong', 'i', 'em', 'u', 'strike', 
      'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 
      'a', 'div', 'span', 'blockquote', 'pre', 'code'
    ],
    ALLOWED_ATTR: ['href', 'target', 'title', 'rel'],
    FORBID_ATTR: ['style', 'class'],
  });
};